import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './Services.styles'

// components
import { LocalisationButton, Grid } from 'components/atoms'

import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { getCookieClient } from 'settings/app/helpers'

const Services = (props) => {
  const { services } = props

  const textContext = React.useContext(TextContext)
  const mandantCookie = getCookieClient()

  const spliceServices = (servicesArr) => {
    servicesArr.splice(3)
    return servicesArr
  }

  return (
    <Styled.Root>
      {mandantCookie?.clientName && (
        <Styled.ServiceHeader container alignItems='center'>
          <Grid item>
            <h2>
              {textContext['localization.services.title']}{' '}
              <span className={ 'mandant' }>{mandantCookie.clientName}</span>
            </h2>
          </Grid>
          <Grid item>
            <LocalisationButton type='small' />
          </Grid>
          <Styled.ServiceIcon className='icon-l-book' />
        </Styled.ServiceHeader>
      )}
      <Styled.ServiceContent container spacing={ 6 }>
        {spliceServices(services).map(
          (service, index) =>
            service.link && (
              <Grid item sm={ 4 } key={ `service-item-${ index }` }>
                <Styled.Service>
                  <Styled.ServiceType>
                    {textContext[`services.type.${ service.type }`]}
                  </Styled.ServiceType>
                  {service.link && (
                    <Styled.ServiceLink
                      isNativeLink
                      href={ service.link.url }
                      className='more-link'>
                      {service.title}
                    </Styled.ServiceLink>
                  )}
                </Styled.Service>
              </Grid>
            )
        )}
      </Styled.ServiceContent>
    </Styled.Root>
  )
}

Services.propTypes = {
  services: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
      }),
      type: PropTypes.string,
      title: PropTypes.string,
    })
  ),
}

export default Services
